import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { ButtonComponent } from '../button/button.component';
import { TranslateModule } from '@ngx-translate/core';

export interface ModalData {
  png: string;
  pdf: string;
}

@Component({
  selector: 'pac-qr-modal',
  templateUrl: './qr-modal.component.html',
  styleUrls: ['./qr-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ButtonComponent,
    MatDialogModule,
    TranslateModule,
  ]
})
export class QrModalComponent {
  public data = inject<ModalData>(MAT_DIALOG_DATA);
}
